import React from 'react';
import './Header.css';
import { Search, ShoppingCart, Bell } from 'lucide-react';
import UserProfile from '../auth/UserProfile'; // Import the new component

const Header = ({ 
  cartItemCount, 
  onSearch, 
  isAuthenticated, 
  user, 
  onLogout,
  authLoading,
  onCartClick,
  onHomeClick
}) => {

  return (
    <header className="app-header">
      <div className="header-container">
        {/* 1. Logo */}
        <div className="header-logo" onClick={onHomeClick} style={{ cursor: 'pointer' }}>
          <img 
            src="/logo_dietalase.png" 
            alt="Dietalase" 
            className="logo-img"
          />
        </div>

        {/* 2. Search Bar */}
        <div className="header-search">
          <input 
            type="text" 
            placeholder="Search for products.." 
            onChange={(e) => onSearch && onSearch(e.target.value)}
          />
          <button className="search-btn">
            <Search />
          </button>
        </div>

        {/* 3. Actions */}
        <div className="header-actions">
          <button className="btn-notification" title="Notifikasi">
            <Bell />
          </button>

          <button className="btn-cart" onClick={onCartClick}>
            <ShoppingCart />
            <span>{cartItemCount > 0 && `(${cartItemCount})`}</span>
          </button>

          {/* Replace the old function with the new component */}
          <UserProfile 
            isAuthenticated={isAuthenticated}
            user={user}
            onLogout={onLogout}
            authLoading={authLoading}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;